module.exports = __webpack_public_path__ + "img/Lpnfreeze.c9a0d3f4.png";